<template>
  <div :class="$style.bind">
    <h1>绑定角色</h1>
    <div :class="$style.content">
      <p>账号：</p>
      <Field v-model.trim="account" :class="$style.field" @blur="handleInputBlur" @change="handleAccountChange"></Field>
      <p>区服：</p>
      <CSelect 
        placeholder="请选择区服"
        :options="serverList"
        :value="server"
        @change="selectServer"
      ></CSelect>
      <p>角色：</p>
      <CSelect 
        placeholder="请选择角色"
        :options="roleList"
        :value="role"
        @change="selectRole"
      ></CSelect>
    </div> 
    <div :class="$style.btnGroup">
      <Button :class="$style.cancel" @click="$emit('close')">取消</Button>
      <Button :class="$style.nextStep" @click="bindRole">绑定</Button>
    </div>
  </div>
</template>

<script>
import { Field, Button } from 'vant';
import CSelect from '@/components/Select'
import { mapActions, mapState, mapMutations } from 'vuex';
import { roleBind } from '@/api/account';
import { isWeiXin } from "@/libs/utils";
import { cyGames } from '@/config/offlinePayGame';

export default {
  name: '',
  data () {
    return {
      account: '',
      server: '',
      server_name: '',
      role: '',
      role_name: '',
      user_id: '',
      lastUserName: '',
    };
  },
  components: {
    Field,
    Button,
    CSelect
  },
  computed: {
    ...mapState({
      serverList: state => state.offlinePay.serverList,
      roleList: state => state.offlinePay.roleList,
      appkey: state => state.offlinePay.appkey,
      gameFlag: state => state.offlinePay.gameFlag,
    })
  },
  methods: {
    ...mapActions({
      getServerInfo: 'offlinePay/getServerInfo',
      getServer: 'offlinePay/getServer',
      getUserRole: "offlinePay/getUserRole",
      getUserList: "offlinePay/getUserList",
      getGoodsList: "offlinePay/getGoodsList"
    }),
    ...mapMutations({
      setOfflinePayState: 'offlinePay/setState'
    }),
    handleAccountChange() {
      this.server = '';
      this.server_name = '';
      this.role = '';
      this.role_name= '';
    },
    async bindRole() {
      if (!this.server || !this.role) {
        this.$toast('请选择角色');
        return;
      }
      const userRole = {
        role_id: this.role,
        role_name: this.role_name,
        server: this.server,
        server_name: this.server_name,
        user_id: this.user_id,
        user_name: this.account,
        game_flag: this.gameFlag
      }
      try {
        if (isWeiXin()) {
          const userInfo = JSON.parse(localStorage.getItem('userInfo'));
          await roleBind({
            union_id: userInfo.union_id,
            appkey: this.appkey,
            user_id: this.user_id,
            server: this.server,
            role_id: this.role,
            server_name: this.server_name,
            role_name: this.role_name
          })
        } else {
          localStorage.setItem('role_info', JSON.stringify(userRole));
        }
        this.setOfflinePayState({
          bindRoleInfo: userRole
        })
        this.$emit('getPayType', { appkey: this.appkey, roleInfo: userRole })
        if (!cyGames.includes(this.gameFlag)) {
          this.getGoodsList()
        }
        this.$toast('绑定成功');
        this.$emit('bindSuccess')    
      } catch (error) {
        if (error.ret === 0) {
          console.log(119, error.content, error.content.type == 1, typeof error.content.type)
          if (error.content && error.content.type == 1) {
            this.$toast('为响应政策，ios未开放该功能');
            // if (['awtjb', 'cqsy'].includes(this.gameFlag)) {
            //   this.$toast('功能暂未开启');
            // } else {
            //   this.$toast('由于相关规范，iOS功能暂不可用');
            // }
          } else {
            this.$toast(error.msg);
          }
        }
      }
    },
    reset() {
      this.account = '';
      this.server = '';
      this.server_name = '';
      this.role = '';
      this.role_name= '';
    },
    selectServer({ text, value, children }) {
      if (value !== this.server) {
        this.server = value;
        this.server_name = text;
        this.role = ''
        if (cyGames.includes(this.gameFlag)) {
          this.setOfflinePayState({ roleList: children });
        } else {
          this.getUserList({ user_name: this.account, server: value })
        }
      }
    },
    selectRole({ text, value, user_id }) {
      this.role = value
      this.role_name = text;
      this.user_id = user_id;
    },
    async handleInputBlur() {
      if (this.account && this.account !== this.lastUserName) {
        if (cyGames.includes(this.gameFlag)) {
          await this.getServerInfo({ user_name: this.account});
        } else {
          await this.getServer({ user_name: this.account});
        }
        this.lastUserName = this.account;
      }
    }
  }
}
</script>

<style lang="scss" module>
.bind {
  width: 278px;
  height: 310px;
  border-radius: 6px;
  // overflow: hidden;
  background: #FFFFFF;
  position: relative;
  > h1 {
    width: 100%;
    height: 41px;
    text-align: center;
    background-color: #CC1109;
    color: #ffffff;
    font-size: 17px;
    // font-weight: bold;
    // border-radius: 6px;
    line-height: 41px;
  }
  .content {
    padding: 15px;
    > p {
      color: #666666;
      font-size: 14px;
      margin-bottom: 6px;
    }
    .field {
      background-color: #E0E0E0;
      border: none;
      padding: 4px 8px;
      margin-bottom: 10px;
    }
    :global {
      .yw-select-wrap {
        width: 100%;
        background-color: #E0E0E0;
        color: #b4afaf;
      }
    }
  }
  .btnGroup {
    position: absolute;
    bottom: 15px;
    left: 15px;
    right: 15px;
    display: flex;
    justify-content: space-between;
    .cancel, .nextStep {
      width: 111px;
      height: 38px;
      border-radius: 6px;
    }
    .cancel {
      border: 1px solid #B2B2B2;
      color: #999999;
    }
    .nextStep {
      background: #CC1109;
      color: #ffffff;
    }
  }
}
</style>